// hooks/useGTMTracking.ts - Version complète avec toutes les fonctions
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
    trackAdhesionStart,
    trackAdhesionStep,
    trackValidationError,
    trackNipVerification,
    trackReferralValidation,
    trackAdhesionSuccess,
    trackAdhesionConversion,
    trackAdhesionFunnelStart,
    trackAdhererClick,
    trackEspaceMembreClick,
    trackMenuClick,
    trackClick,
    trackMemberLogin,
    trackMemberLoginFailed,
    trackMemberCardDownload,
    trackAdhesionPDFGeneration,
    trackSocialShare,
    trackReferralLinkCopy,
    trackQRCodeView,
    trackQRCodeDownload,
    trackSectionView,
    trackPageLoadTime,
    trackTechnicalError,
    trackPageView,
    trackStepTime,
    testGTMService
} from '../services/gtmTracking';

export const useGTMTracking = () => {
    const location = useLocation();
    const stepTimerRef = useRef<{ [key: string]: number }>({});

    // Test du service au chargement (une seule fois)
    useEffect(() => {
   //     console.log('🔧 useGTMTracking hook initialized');
        testGTMService();
    }, []);

    // Tracker automatiquement les changements de page
    useEffect(() => {
        const page_title = document.title;
        const page_location = window.location.href;
        trackPageView(page_title, page_location);
    }, [location.pathname]);

    // Fonctions utilitaires pour les timers
    const startStepTimer = (stepName: string) => {
        stepTimerRef.current[stepName] = Date.now();
    //    console.log(`⏱️ Started timer for step: ${stepName}`);
    };

    const endStepTimer = (stepName: string) => {
        if (stepTimerRef.current[stepName]) {
            const timeSpent = Math.round((Date.now() - stepTimerRef.current[stepName]) / 1000);
            trackStepTime(stepName, timeSpent);
            delete stepTimerRef.current[stepName];
       //     console.log(`⏱️ Ended timer for step: ${stepName} (${timeSpent}s)`);
        }
    };

    // Retourner toutes les fonctions de tracking
    return {
        // Événements d'adhésion
        trackAdhesionStart,
        trackAdhesionStep,
        trackValidationError,
        trackNipVerification,
        trackReferralValidation,
        trackAdhesionSuccess,
        trackAdhesionConversion,
        trackAdhesionFunnelStart,

        // Événements de navigation
        trackAdhererClick,
        trackEspaceMembreClick,
        trackMenuClick,
        trackClick,

        // Événements espace membre
        trackMemberLogin,
        trackMemberLoginFailed,
        trackMemberCardDownload,
        trackAdhesionPDFGeneration,

        // Événements de partage social
        trackSocialShare,
        trackReferralLinkCopy,

        // Événements d'interaction
        trackQRCodeView,
        trackQRCodeDownload,
        trackSectionView,

        // Événements généraux
        trackPageLoadTime,
        trackTechnicalError,
        trackPageView,
        trackStepTime,

        // Fonctions utilitaires
        startStepTimer,
        endStepTimer,

        // Test
        testGTMService
    };
};
